export default `---
slug: salesforce-prompt-builder
title: "Salesforce Prompt Builder"
year: 2024
category: work
featured: false
tags: [Salesforce, GenAI, Prompt Engineering, AI, Swift, Customer Support]
thumbnail: /images/projects/22_salesforce_prompt_builder.png
description: "a number I'm contractually not allowed to share — the first GenAI project at Swift, my catalyst into AI, and the one that got me to speak at Dreamforce Amsterdam."
relatedLinks:
  - label: "Swift — Enterprise AI"
    href: /career/swift-enterprise-ai
  - label: "RPA Automation Project"
    href: /projects/rpa-automation
---
![salesforce prompt builder](/images/projects/22_salesforce_prompt_builder.png)

This project has been the first project I did around AI at work and it was the catalyst for my career in AI. It all started in early 2024 when I was still a customer support engineer at Swift, and the company began exploring AI solutions.

As of August 1st 2025 *(which is two days before I wrote this piece)*, I'm officially part of the Enterprise AI team at work. Looking back now, it's pretty wild to think that everything traces back to this one project. *(Sometimes the universe has a funny way of connecting the dots, doesn't it?)*

## The Project

The project centered around Salesforce's Prompt Builder — their AI feature that lets you create prompt templates and ground them with actual CRM data from the Salesforce database. The setup: create your prompts, pull in relevant customer data, run everything through a series of security and privacy checks *(because we're in a highly regulated environment)*, and send it off to the LLM for a response.

The project was led by **Christophe**, who was leading the CI (Customer Interactions) tribe back then and is now my manager in Enterprise AI. We focused on three core use cases:

- **Internal case summaries** — helping support engineers quickly synthesize complex customer issues
- **First reply drafts** — generating initial customer responses that could be refined and personalized
- **Knowledge article creation** — turning case resolutions into reusable documentation

## My Role

At the time, I was working as a customer support engineer, so I was perfectly positioned to be the voice of the business side. I gathered requirements, provided feedback during testing, and helped ensure we were actually solving real problems.

But my AI background started becoming invaluable as the project progressed. I found myself diving deeper into the technical side, **refactoring the prompts myself** and implementing the latest prompt engineering techniques I'd been learning about.

## The Recognition

The project's success opened doors I hadn't even imagined. I got to present at several company town halls, sharing our experience with colleagues across the organization.

Then came the cherry on top — **Salesforce invited us to their Dreamforce event in Amsterdam in Fall 2024**. We did a 15-minute interview sharing our experience implementing Prompt Builder. Standing there, talking about our project at a vendor tech conference... it was surreal.

But perhaps the most meaningful part was getting the chance to sit down and personally speak with company executives about the project — conversations with **Pat Antonacci** *(former Customer Experience Executive)* and **Thierry Chilosi** *(Business Development & Strategy Officer)* that went beyond just project updates and really dove into the strategic implications of what we were building.

This project became my proving ground. It allowed me to demonstrate not just technical competence, but also business acumen, project management skills, and the ability to bridge the gap between AI capabilities and real-world business needs.
`;
